<template>
    <div class="settings-card danger-card">
        <div class="card-header">
            <h2>Reset Settings</h2>
        </div>
        <div class="card-content">
            <div class="setting-row">
                <div class="setting-info">
                    <label class="setting-label">Reset to Defaults</label>
                    <span class="setting-description">
                        Restore all settings to their default values
                    </span>
                </div>
                <button
                    @click="$emit('reset-click')"
                    class="reset-btn"
                >
                    Reset All
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ResetSettingsCard',
    emits: ['reset-click']
};
</script>

<style scoped>
.settings-card {
    background: var(--bg-primary);
    border: 1px solid rgba(var(--accent-rgb), 0.6);
    overflow: hidden;
}

.settings-card.danger-card {
    border-color: rgba(255, 68, 68, 0.3);
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 30px;
    background: var(--bg-secondary);
    border-bottom: 1px solid var(--accent);
}

.danger-card .card-header {
    background: rgba(255, 68, 68, 0.05);
    border-bottom-color: rgba(255, 68, 68, 0.1);
}

.card-header h2 {
    margin: 0;
    color: var(--text-secondary);
    font-size: 24px;
}

.danger-card .card-header h2 {
    color: #ff6b6b;
}

.card-content {
    padding: 30px;
}

.setting-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
}

.setting-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.setting-label {
    color: var(--text-secondary);
    font-size: 16px;
    font-weight: 500;
}

.setting-description {
    color: rgba(var(--text-primary-rgb), 0.6);
    font-size: 14px;
    line-height: 1.4;
}

.reset-btn {
    padding: 12px 24px;
    background: transparent;
    color: #ff6b6b;
    border: 2px solid #ff6b6b;
    cursor: pointer;
    transition: all 0.2s;
    font-size: 14px;
    font-weight: 600;
}

.reset-btn:hover {
    background: #ff6b6b;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(255, 68, 68, 0.3);
    color: var(--bg-primary);
}

@media (max-width: 768px) {
    .card-header {
        padding: 15px 20px;
    }

    .card-content {
        padding: 20px;
    }

    .setting-row {
        flex-direction: column;
        align-items: flex-start;
    }
}
</style>
